/* global require */

// install polyfill for setImmediate
if (!window.setImmediate) {
    require('setimmediate');
}

// Create Element.remove() function if not exists.
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

// Add forEach to NodeList.
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i += 1) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// Add String.includes().
if (!String.prototype.includes) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(String.prototype, 'includes', {
        value: function(search, start) {
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            }

            return this.indexOf(search, start) !== -1;
        }
    });
}

// Add CustomEvent functionality for IE.
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
if (typeof window.CustomEvent !== 'function') {
    // eslint-disable-next-line no-inner-declarations
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent('Event');
        evt.initEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}

// Add MouseEvent funcionality for IE.
// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#Polyfill
if (typeof window.MouseEvent !== 'function') {
    // Polyfills DOM4 MouseEvent
    const MouseEventPolyfill = function(eventType, params) {
        params = params || { bubbles: false, cancelable: false };
        const mouseEvent = document.createEvent('MouseEvent');
        mouseEvent.initMouseEvent(
            eventType,
            params.bubbles,
            params.cancelable,
            window,
            0,
            params.screenX || 0,
            params.screenY || 0,
            params.clientX || 0,
            params.clientY || 0,
            params.ctrlKey || false,
            params.altKey || false,
            params.shiftKey || false,
            params.metaKey || false,
            params.button || 0,
            params.relatedTarget || null
        );

        return mouseEvent;
    };

    MouseEventPolyfill.prototype = Event.prototype;

    window.MouseEvent = MouseEventPolyfill;
}

// Add reportValidity functionality to HTMLInputElement and HTMLSelectElement on IE.
if (!('reportValidity' in HTMLInputElement.prototype)) {
    const reportValidity = function() {
        if (this.checkValidity()) {
            return true;
        }
        this.focus();
        if (this.validationMessage) {
            // eslint-disable-next-line no-alert
            alert(this.validationMessage);
        }
        return false;
    };

    HTMLInputElement.prototype.reportValidity = reportValidity;
    HTMLSelectElement.prototype.reportValidity = reportValidity;
}
